/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import useForm from "../../../hooks/useForm";

import { Card } from "reactstrap";
import Button from "../../../components/Button";
import Form from "../../../components/Form";
import systemAlert from "../../../utils/systemAlert";

import { CATEGORY_SETTINGS_OPTIONS } from "../../../constants/CATEGORY";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

import { getSettings, modifySettings } from "../../../apis/finances/accounting-title";

const CategorySettings = (props) => {
  const history = useHistory()
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );

  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions))
    {
      const permission = permissions.find(p => p.code === 'FUND_CLAIM_OBLIGATION')
      setTargetPermission(permission)
      if (isEmpty(permission))
      {
        permissionCheck(history, "FUND_CLAIM_OBLIGATION")
      }
    }
  }, [permissions])


  const [fields] = useState([
    [
      {
        title: "매출원가 (451~470)",
        key: "costOfSales",
        type: "select",
        width: 250,
        options: {
          list: CATEGORY_SETTINGS_OPTIONS,
        },
        required: true,
      },
      {
        title: "제조원가 (501~600)",
        key: "costOfManufacturing",
        type: "select",
        width: 250,
        options: {
          list: CATEGORY_SETTINGS_OPTIONS,
        },
        required: true,
      },
      {
        title: "도급원가 (601~650)",
        key: "costOfContract",
        type: "select",
        width: 250,
        options: {
          list: CATEGORY_SETTINGS_OPTIONS,
        },
        required: true,
      },
    ],
    [
      {
        title: "보관원가 (651~700)",
        key: "costOfStorage",
        type: "select",
        width: 250,
        options: {
          list: CATEGORY_SETTINGS_OPTIONS,
        },
        required: true,
      },
      {
        title: "분양원가(701~750)",
        key: "costOfSelling",
        type: "select",
        width: 250,
        options: {
          list: CATEGORY_SETTINGS_OPTIONS,
        },
        required: true,
      },
      {
        title: "운송원가 (751~800)",
        key: "costOfTransportation",
        type: "select",
        width: 250,
        //className: "font-size-13 ",
        options: {
          list: CATEGORY_SETTINGS_OPTIONS,
        },
        required: true,
      },
    ],
  ]);

  const defaultForm = {
    costOfSales: 0, //"매출원가"
    costOfManufacturing: 0, //"제조원가"
    costOfContract: 0, // "도급원가"
    costOfStorage: 0, // "보관원가"
    costOfSelling: 0, // "분양원가"
    costOfTransportation: 0, // "운송원가"
  }

  const {
    form,
    setForm,
    handleOnChange,
  } = useForm(
    defaultForm,
  );  

  const _getData = async() => {
    getSettings()
      .then((res) => {
        const data = res.data
        delete data.companyIdx
        setForm(data)
      })
      .catch(() => {})
  }

  useEffect(() => {    

    setForm(defaultForm)
    _getData()

  }, [])

  const _submit = () => {
    console.log("form: ", form)

    systemAlert(`카테고리 검색 설정을 등록하시겠습니까?`, {

      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '저장',
          onClick: () => {
            modifySettings(form)
              .then(() => {
              })
          }
        }
      ]
    })
  }

  return (
    !isEmpty(targetPermission) && (
      <>
        
        <div style={{width: 760}}>
        <Card>
        <Form
          form={form}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
        />
        </Card>
        </div>  
        <div style={{width: 760}}>
          <div className="submit-button-wrap float-right">
            <Button
              className="button"
              label="설정하기"
              size="md"
              action={_submit}
            />
          </div>
        </div>
      </>
    )
  );
};

export default CategorySettings;
